export default "__VITE_ASSET__bf5640ff__"